import React, { useState, useEffect } from "react";

const ClientRewards = ({ userDetails }) => {
  const [rewardHistory, setRewardHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Fetch reports only for the logged-in user
    const fetchReports = async () => {
      try {
        // Make an API request with the user ID from userDetails
        const response = await fetch(`https://api.swalokgroup.com/api/get-reward`);
        if (!response.ok) {
          throw new Error("Failed to fetch rewards");
        }
        const data = await response.json();
        data.sort((a, b) => new Date(b.reward_date) - new Date(a.reward_date));
        const filteredRewards = data.filter(
          (reward) => reward.client_id === userDetails.client_id
        );

        setRewardHistory(filteredRewards); // Store the reports data in state
      } catch (error) {
        console.log(error.message);
      } finally {
        setLoading(false); // Set loading to false after the request completes
      }
    };

    fetchReports();
  }, [userDetails.client_id]); // Trigger the effect whenever the userDetails.id changes

  const formatDate = (dateString) => {
    const date = new Date(dateString); // Create Date object
    return date.toLocaleDateString(); // Default format is 'MM/DD/YYYY' in the browser's locale
  };

  const totalRewardAmount = rewardHistory.reduce(
    (total, reward) => total + parseFloat(reward.amount),
    0
  );

  return (
    <>
      <section className="py-5">
        <div className="container">
          <div className="sec-subheading">
            <hr />
            <span>My Rewards History</span>
            <hr />
          </div>

          <p className="fw-semibold my-4">
            Total Rewards ₹{totalRewardAmount.toFixed(2)}
          </p>
          <div className="table-responsive text-center">
            <table className="w-100 text-capitalize">
              <thead>
                <tr className="bg-light para-text">
                  <th className="py-3 px-2">Claimed On</th>
                  <th className="py-3 px-2">Amount</th>
                  <th className="py-3 px-2">TDS Amount</th>
                  <th className="py-3 px-2">Recieved</th>
                  <th className="py-3 px-2">Category</th>
                  <th className="py-3 px-2">Status</th>
                </tr>
              </thead>

              <tbody>
                {loading && (
                  <tr>
                    <td colSpan="4" className="py-3 px-2">
                      Loading rewards...
                    </td>
                  </tr>
                )}

                {rewardHistory.length === 0 ? (
                  <tr>
                    <td colSpan="6" className="py-3 px-2">
                      No rewards found
                    </td>
                  </tr>
                ) : (
                  rewardHistory.map((rewards, index) => (
                    <tr className="text-muted para-text" key={index}>
                      <td className="py-3 px-2">
                        {formatDate(rewards.reward_date)}
                      </td>
                      <td className="py-3 px-2">₹{rewards.amount}</td>
                      <td className="py-3 px-2">₹{rewards.amount * 0.05}</td>
                      <td className="py-3 px-2">₹{rewards.amount - rewards.amount * 0.05}</td>
                      <td className="py-3 px-2">{rewards.category}</td>
                      <td
                        className={`py-3 px-2 cursor-pointer ${
                          rewards.is_approved ? "text-success" : "text-danger"
                        }`}
                      >
                        {rewards.is_approved ? "Approved" : "Pending"}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </>
  );
};

export default ClientRewards;
